import RubyStoreContainer from './ruby-store-container'

export default RubyStoreContainer
